// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f26Bf1dSnFdFHnaro0Aj{display:flex;flex-direction:column;gap:3px}.HaJqymjQ3B3SM13JiXyx{color:var(--content-primary-tertiary)}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/doubleOptIn/ui/doubleOptInHeader/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,OAAA,CAEA,sBACE,qCAAA","sourcesContent":[".header {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n\n  &Description {\n    color: var(--content-primary-tertiary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `f26Bf1dSnFdFHnaro0Aj`,
	"headerDescription": `HaJqymjQ3B3SM13JiXyx`
};
export default ___CSS_LOADER_EXPORT___;
